import { useCallback, useMemo, useState } from "react";

import { useParams } from "@tanstack/react-router";
import { Alert, Flex } from "antd";

import { PopupForm } from "#components";
import { InfiniteScrollListPage } from "#layouts";

import { analyticsEntities } from "../analyticsConfig";

import styles from "../Analytics.module.scss";

export const AnalyticsEntityView = () => {
	const params = useParams({ strict: false });
	const { entityKey } = params as Record<string, string>;

	const entity = useMemo(
		() => analyticsEntities.find((item) => item.key === entityKey),
		[entityKey]
	);

	const [formOpen, setFormOpen] = useState(false);
	const [formEntityName, setFormEntityName] = useState<string | null>(null);
	const [formRecordID, setFormRecordID] = useState<string | null>(null);

	const handleReportRowClick = useCallback(
		(rowData: Record<string, unknown>) => {
			const entityName = rowData.entity_name;
			const entityID = rowData.entity_id;
			if (typeof entityName !== "string" || !entityName) {
				return;
			}
			if (entityID === undefined || entityID === null) {
				return;
			}
			if (typeof entityID !== "string" && typeof entityID !== "number") {
				return;
			}
			setFormEntityName(entityName);
			setFormRecordID(String(entityID));
			setFormOpen(true);
		},
		[]
	);

	const handleReportFormClose = useCallback(() => {
		setFormOpen(false);
		setFormEntityName(null);
		setFormRecordID(null);
	}, []);

	if (!entity) {
		return (
			<Alert
				type="warning"
				message="Report not found"
				description={`No analytics report configured for "${entityKey}".`}
				showIcon
			/>
		);
	}

	return (
		<Flex vertical flex={1} className={styles.entityView}>
			<Flex flex={1} vertical className={styles.reportContent}>
				<InfiniteScrollListPage
					queryCode={entity.queryCode}
					scope={`analytics-${entityKey}`}
					onRowClick={handleReportRowClick}
				/>
			</Flex>
			{formEntityName !== null && formRecordID !== null && (
				<PopupForm
					open={formOpen}
					entityName={formEntityName}
					mode="edit"
					recordID={formRecordID}
					onClose={handleReportFormClose}
				/>
			)}
		</Flex>
	);
};
